import { InfoCircleOutlined } from '@ant-design/icons';
import { Alert, Col, Row, Skeleton, Spin, Tooltip, Checkbox } from 'antd';
import MultipleSelectUsers from './MultipleSelectUsers';
import { useEffect, useState } from 'react';
import { api } from 'services/api';
import { FormattedMessage } from 'react-intl';

function NotifiableUsers() {
	const [domain, setDomain] = useState(false);
	const [users, setUsers] = useState([]);
	const [selectedUsers, setSelectedUsers] = useState([]);
	const [isSaving, setIsSaving] = useState(false);
	const [successEditingNotifiableUsers, setSuccessEditingNotifiableUsers] = useState(false);
	const [errorEditingNotifiableUsers, setErrorEditingNotifiableUsers] = useState(false);
	const [isLoading, setIsLoading] = useState(true);
	const [isEditing, setIsEditing] = useState(false);
	const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);

	useEffect(() => {
		window.BX24.init(async () => {
			const auth = window.BX24.getAuth();
			const domain = auth.domain;
			setDomain(domain);

			await getUsers(domain);
			await getNotifiableUsers(domain);
			await getCheckboxNotificationState(domain);
			setIsLoading(false);
		});

		const getCheckboxNotificationState = async (domain) => {
			try {
				const { data } = await api.post('getCheckboxNotificationState', { domain });
				console.log(data);
				setIsCheckboxChecked(data);
			} catch (error) {
				console.error('Erro ao buscar o estado do checkbox:', error);
			}
		};

		const getUsers = async (domain) => {
			const { data } = await api.post('getUsers', { domain });
			setUsers(data);
		};

		const getNotifiableUsers = async (domain) => {
			const { data } = await api.get(`getNotifiableUsers/${domain}`);
			setSelectedUsers(data);
		};
	}, []);

	const handleCheckboxChange = async (e) => {
		const checked = e.target.checked;
		console.log(checked);
		setIsCheckboxChecked(checked);

		try {
			// Envie a atualização para o backend
			await api.post('saveCheckboxNotification', {
				domain,
				isChecked: checked,
			});
		} catch (error) {
			console.error('Erro ao atualizar o estado do checkbox:', error);
		}
	};
	const handleSaveClick = async () => {
		setIsSaving(true);
		await api
			.post('editNotifiableUsers', {
				selectedUsers,
				domain,
			})
			.then((response) => {
				if (response.status === 200) {
					setSuccessEditingNotifiableUsers(true);
				}
			})
			.catch((err) => {
				console.log(err);
				setErrorEditingNotifiableUsers(true);
			});
		setIsSaving(false);
		setIsEditing(false);
	};

	const handleEditClick = async () => {
		setIsEditing(true);
	};

	const handleSuccessAlertClose = (type) => {
		setSuccessEditingNotifiableUsers(false);
	};

	const handleErrorAlertClose = (type) => {
		setErrorEditingNotifiableUsers(false);
	};

	return (
		<div
			style={{
				backgroundColor: '#e8f9fe',
				padding: 12,
				borderBottom: '1px solid #fff',
			}}
		>
			{successEditingNotifiableUsers && (
				<Alert
					message={<FormattedMessage id="notifiable_save_success" />}
					type="success"
					showIcon
					closable
					style={{ marginBottom: 8 }}
					onClose={handleSuccessAlertClose}
				/>
			)}

			{errorEditingNotifiableUsers && (
				<Alert
					message={<FormattedMessage id="notifiable_save_error" />}
					type="error"
					showIcon
					closable
					style={{ marginBottom: 4 }}
					onClose={handleErrorAlertClose}
				/>
			)}

			<Skeleton loading={isLoading} paragraph={{ rows: 1 }} title={false}>
				<Row>
					<Col
						span={6}
						style={{
							lineHeight: '25px',
						}}
					>
						<span style={{ fontWeight: 'bold' }}>
							<FormattedMessage id="notified_users" />
						</span>
						<Tooltip title={<FormattedMessage id="notifiable_tooltip" />}>
							<InfoCircleOutlined
								style={{
									color: '#08AAF2',
									marginLeft: 5,
								}}
							/>
						</Tooltip>
					</Col>
					<Col
						span={12}
						style={{
							lineHeight: '25px',
						}}
					>
						{isEditing ? (
							<MultipleSelectUsers
								users={users}
								selectedUsers={selectedUsers}
								setSelectedUsers={setSelectedUsers}
								isLoading={isLoading}
							/>
						) : (
							<div>
								{selectedUsers.map((user, index, selectedUsers) => (
									<span key={index}>
										{user?.fullName || ''}
										{index < selectedUsers.length - 1 ? ', ' : ''}
									</span>
								))}
							</div>
						)}
						<Checkbox checked={isCheckboxChecked} onChange={handleCheckboxChange}>
							<FormattedMessage id="notification_checkbox" />
							<Tooltip
								title={
									<div>
										<br />
										<FormattedMessage id="info_notification" />
										<br />
										<FormattedMessage id="info_notification_2" />
										<br />
										<FormattedMessage id="info_notification_3" />
										<br />
										<FormattedMessage id="info_notification_4" />
									</div>
								}
							>
								<InfoCircleOutlined
									style={{
										color: '#08AAF2',
										marginLeft: 5,
									}}
								/>
							</Tooltip>
						</Checkbox>
					</Col>
					<Col
						span={6}
						style={{
							lineHeight: '25px',
							fontWeight: 'bold',
						}}
					>
						{isEditing ? (
							<button
								style={{ cursor: 'pointer' }}
								className="btn-permission float-right"
								onClick={handleSaveClick}
							>
								{isSaving ? <Spin /> : <FormattedMessage id="save" />}
							</button>
						) : (
							<button
								style={{ cursor: 'pointer' }}
								className="btn-permission float-right"
								onClick={handleEditClick}
							>
								<FormattedMessage id="edit" />
							</button>
						)}
					</Col>
				</Row>
			</Skeleton>
		</div>
	);
}

export default NotifiableUsers;
